import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52d80d28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-layout" }
const _hoisted_2 = { class: "auth-layout-bg" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_5 = {
  class: "auth-layout-content",
  ref: "refScrollBlock"
}
const _hoisted_6 = {
  key: 0,
  class: "logo-container"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-black" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: require('@/assets/' + $setup.getImgBg),
        alt: "Fit women"
      }, null, 8, _hoisted_3),
      _createVNode(_component_router_link, { to: { name: 'Landing' } }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: _normalizeClass(["auth-layout-content-inner", { 'align-items-top ': $setup.currentRoute === 'OnboardingStep' }])
      }, [
        ($setup.currentRoute !== 'OnboardingStep')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                class: "display-on-mobile",
                to: { name: 'Landing' }
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_view, null, {
          default: _withCtx(({ Component }) => [
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { bottomArrived: $setup.getBottomArrived }, null, 8, ["bottomArrived"]))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ], 2)
    ], 512)
  ]))
}